<template>
    <div class="load-more">
        <div class="load-more-badge" v-if="!isCompleted()" @click="loadMore" :class="{ loading: isLoading() }">
            <i class="material-icons arrow-icon" v-if="!isLoading()">expand_less</i>
            <i class="material-icons loading-icon rotating" v-if="isLoading()">autorenew</i>
            <span class="badge-text">
                {{ isLoading() ? $t("auto.loading") : $t("auto.loadMore") }}
            </span>
            <span class="badge-count">{{ $t("chart.loadMoreMessagesProgress", { current: totalReceived(), total: history().totalCount }) }}</span>
        </div>
        <div class="load-more-badge completed" v-else>
            <i class="material-icons completed-icon">done</i>
            <span class="badge-text">{{ $t("message.allHistoryLoaded") }}</span>
            <span class="badge-count">{{ $t("chart.loadMoreMessagesTotal", { total: history().totalCount }) }}</span>
        </div>
    </div>
</template>
<script>
import { log2 } from "../../../utils/log2";
import { mapState } from "vuex";
import _ from "lodash";
import SYSTEM_PUBSUB from "../../../utils/systemPubSub";

const log = log2("LoadMoreMessage");
export default {
    name: "LoadMoreMessage",
    props: {
        conversationId: {
            type: String,
        },
        contactId: {
            type: String,
        },
    },
    data() {
        return {
            renderId: 1,
        };
    },
    computed: {
        ...mapState({
            isTeamChat: function (state) {
                return !!state.team.chats.find((x) => x._id === this.conversationId);
            },
            chatHistory: (state) => state.chat.chatHistory,
            messagesByContact: (state) => state.contact.messagesByContact,
        }),
    },
    methods: {
        loadMore() {
            log("loadMore");
            if (this.isTeamChat) {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.TEAM_CONVERSATION_LOAD_MORE, {
                    conversationId: this.conversationId,
                });
            } else {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.ACTIVE_CONVERSATION_LOAD_MORE, {});
            }
        },
        history() {
            if (this.contactId) {
                return (
                    this.messagesByContact[this.contactId] || {
                        data: [],
                        totalPage: 0,
                        totalCount: 0,
                        offset: -20,
                        limit: 20,
                        loading: false,
                    }
                );
            } else {
                return (
                    this.chatHistory[this.conversationId] || {
                        data: [],
                        totalPage: 0,
                        totalCount: 0,
                        offset: -20,
                        limit: 20,
                        cachedChatIds: [],
                    }
                );
            }
        },
        isCompleted() {
            const history = this.history();
            const totalReceived = this.totalReceived();
            return totalReceived >= history.totalCount;
        },
        isLoading() {
            const history = this.history();
            return history.loading;
        },
        totalReceived() {
            const history = this.history();
            const invalidTypes = ["conversation-separator", "divider", "day-separator"];
            return history.data.filter((m) => !invalidTypes.includes(m.messageType)).length;
        },
    },
    mounted() {},
    // watch: {
    //     chatHistory: {
    //         handler() {
    //             this.renderId++;
    //             this.$forceUpdate();
    //         },
    //         deep: true,
    //     },
    // },
};
</script>
<style lang="scss">
.sc-message.load-more {
    width: 300px !important;
}

.load-more {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 8px 0;

    .load-more-badge {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 6px 12px;
        background: rgb(255, 238, 235);
        border-radius: 12px;
        cursor: pointer;
        user-select: none;
        transition: all 0.2s ease;
        font-size: 12px;
        color: #595959;
        font-weight: 400;

        .material-icons {
            font-size: 12px;
            transition: all 0.2s ease;
            background: rgba(253, 97, 68, 0.8);
            color: rgb(255, 238, 235);
            border-radius: 50%;
            width: 15px;
            height: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .rotating {
            animation: rotate 1s linear infinite;
        }

        .badge-text {
            white-space: nowrap;
        }

        .badge-count {
            font-size: 11px;
            color: #8c8c8c;
            margin-left: 2px;
        }

        &:hover:not(.completed):not(.loading) {
            background: rgb(255, 230, 225);
            transform: translateY(-1px);

            .arrow-icon {
                transform: translateY(-2px);
            }
        }

        &:active:not(.completed):not(.loading) {
            transform: translateY(0);
        }

        &.loading {
            cursor: wait;
        }

        &.completed {
            background: rgb(240, 255, 244);
            cursor: default;

            .completed-icon {
                background: rgba(82, 196, 26, 0.8);
                color: rgb(240, 255, 244);
            }

            .badge-count {
                color: #8c8c8c;
            }

            &:hover {
                transform: none;
            }
        }
    }
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
